import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from 'src/environments/environment';
declare var require: any;

@Component({
  selector: 'obsjwe-obsidiam-jwe',
  template: `
    <p>
      Estas usando la libreria JWE Obsidiam
    </p>
  `,
  styles: [
  ]
})

export class ObsidiamJweComponent implements OnInit {
  endPoints: any;
  endPointIsJwe = false;

  private keyJwe;
  constructor() {
    this.endPoints = sessionStorage.getItem('endPoints');
    if (this.endPoints)
      this.endPoints = JSON.parse(this.endPoints);
    this.keyJwe = environment.keyJwe;
    this.encriptJweSecret();
  }

  ngOnInit(): void {
  }


  private isEndPointIsJwe(urlWebService: any) {
    if (!this.endPoints) {
      this.endPoints = sessionStorage.getItem('endPoints');
      this.endPoints = JSON.parse(this.endPoints);
    }
    if (this.endPoints) {
      return this.endPoints.filter(x => x === urlWebService).length > 0;
    }
  }

  async encodeJwe(urlWebService, param, callback) {
    this.endPointIsJwe = this.isEndPointIsJwe(urlWebService);
    if (this.endPointIsJwe) {
      const jose = require('node-jose');

      const opts = {
        algorithms: [{
          alg: 'A256KW',
          enc: 'A128GCM'
        }],
        format: 'compact',
        k: this.keyJwe
      };

      return await jose.JWK.asKey({
        algorithms: [{
          alg: 'A256KW',
          enc: 'A128GCM'
        }],
        kty: 'oct',
        k: btoa(this.keyJwe),
        alg: 'A256KW'
      }).
        then(key => {
          return jose.JWE.createEncrypt(opts, key).final(JSON.stringify(param), 'utf8')
            .then((response) => {
              callback(response);
            });
        });
    } else {
      return callback(param);
    }

  }

  async encodeJweForNotObsicashAPI(urlWebService, param, callback) {
    if (urlWebService) {
      const jose = require('node-jose');

      const opts = {
        algorithms: [{
          alg: 'A256KW',
          enc: 'A128GCM'
        }],
        format: 'compact',
        k: this.keyJwe
      };

      return await jose.JWK.asKey({
        algorithms: [{
          alg: 'A256KW',
          enc: 'A128GCM'
        }],
        kty: 'oct',
        k: btoa(this.keyJwe),
        alg: 'A256KW'
      }).
        then(key => {
          return jose.JWE.createEncrypt(opts, key).final(JSON.stringify(param), 'utf8')
            .then((response) => {
              callback(response);
            });
        });
    } else {
      return callback(param);
    }

  }
  
  async decodeJweCallback(res, callback) {

    const jose = require('node-jose');

    return await jose.JWK.asKey({
      algorithms: [{
        "alg": "A256KW",
        "enc": "A128GCM"
      }],
      kty: "oct",
      k: btoa(this.keyJwe),
      alg: "A256KW"
    })
      .then(key => {
        return jose.JWE.createDecrypt(key)
          .decrypt(res)
          .then(res => res.payload.toString())
          .then(payload => JSON.parse(payload))
          .then(response => {
            callback(response);
          })
      });
  }

  async decodeJwe(codejwe) {

    const jose = require('node-jose');

    return await jose.JWK.asKey({
      algorithms: [{
        alg: 'A256KW',
        enc: 'A128GCM'
      }],
      kty: 'oct',
      k: btoa(this.keyJwe),
      alg: 'A256KW'
    })
      .then(key => {
        return jose.JWE.createDecrypt(key)
          .decrypt(codejwe)
          .then(res => res.payload.toString())
          .then(payload => JSON.parse(payload))
          .then(response => {
            return response;
          });
      });
  }


  public mapObservable(observable: Observable<any>) {
    return observable
      .map((res) => {
        return this.decodeJwe(res);
      });
  }


  private encriptJweSecret() {
    let newJwe = '';
    for (let i = 0; i < this.keyJwe.length - 1; i = i + 2) {
      newJwe = newJwe + this.keyJwe[i + 1];
      newJwe = newJwe + this.keyJwe[i];
    }
    this.keyJwe = newJwe;
  }
}
